import React, { useEffect, useMemo, useState } from "react";
import ArticleCard from "./ArticleCard";
import ReactPaginate from 'react-paginate';

const ArticlesBlock = () => {
  const [articlesList, setArticlesList] = useState([]);
  const [articles, setArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);
  const [category, setCategory] = useState('all');
  const [tabs, setTabs] = useState([{text: 'Search by Topic:'}, {name: 'all', id: 'all', slug: 'all'}]);
  const [categoryId, setCategoryId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const url = window.location.origin;

  const filterByCategory = async (id) => {
    const request = await fetch(
      `${url}/wp-json/wp/v2/resource?resource_category=${id}&per_page=100`
    );
    if (request.status === 200){
      return request.json();
    }
  }

  const getCategories = async () => {
    const request = await fetch(
      `${url}/wp-json/wp/v2/resource_category`
    );
    if (request.status === 200){
      return request.json();
    }
  }

  const getAllArticles = async () => {
    const request = await fetch(
      `${url}/wp-json/wp/v2/resource?per_page=100`
    );
    if (request.status === 200){
      return request.json();
    }
  }

  const searchArticles = async (query) => {
    const request = await fetch(
      `${url}/wp-json/wp/v2/search?search=${query}&per_page=100&page=1&type=post&subtype=resource`
    );
    if (request.status === 200){
      return request.json();
    }
  }

  const getArticleById = async (id) => {
    const request = await fetch(
      `${url}/wp-json/wp/v2/resource/${id}`
    );
    if (request.status === 200){
      return request.json();
    }
  }

  useEffect(() => {
    getCategories().then((res) => {
      const newTabs = [...tabs];
      if (res.length) {
        res.forEach((tab) => {
          newTabs.push(tab)
        })
      }
      setTabs(newTabs);
    })
  }, []);

  useEffect(() => {
    setLoading(true);
    if (category !== 'all' && !isSearching) {
      filterByCategory(categoryId).then((res) => {
        setArticlesList(res.length ? res : []);
        setLoading(false);
      }).catch((error) => {
        console.error("Error filtering by category:", error);
        setLoading(false);
      });
    } else if (!isSearching) {
      getAllArticles().then((res) => {
        setArticlesList(res.length ? res : []);
        setLoading(false);
      }).catch((error) => {
        console.error("Error fetching all articles:", error);
        setLoading(false);
      });
    }
  }, [category, categoryId, isSearching]);

  useEffect(() => {
    setPage(1)
  }, [category]);

  useEffect(() => {
    setPagesCount(Math.ceil(articlesList.length / 12));
  }, [articlesList]);

  useEffect(() => {
    const articlesListClone = [...articlesList];
    const startIndex = 12 * page - 12;
    const deleteCount = articlesList.length < 12 * pagesCount && page === Math.ceil(articlesList.length / 12)
      ? 12 - (12 * page - articlesList.length)
      : 12;
    const newArticlesList = articlesListClone.splice(startIndex, deleteCount);
    setArticles(newArticlesList);
  }, [page, articlesList, pagesCount]);

  const selectCategory = (cat) => {
    setCategory(cat.name);
    if(cat.name !== 'all'){
      setCategoryId(cat.id)
    }else {
      setCategoryId(null)
    }
    setSearchQuery('');
    setIsSearching(false);
  };

  const articlesCardsList = useMemo(() => {
    if (articles.length === 0) {
      return (
        <div className="clockworks-articles-nodata-container">
          <h2>{isSearching ? "Your search yielded no results." : "There are no articles in this category"}</h2>
        </div>
      );
    } else {
      return articles.map((article, index) => {
        const { resource_categories: categoryResource, hero_image: img, title, link, button_text: buttonText, alternative_url: alternativeUrl} = article;
        return (
          <ArticleCard
            key={`${title?.rendered}--${index}`}
            description={categoryResource?.name || ''}
            title={title?.rendered || ''}
            img={img ? img[0][0] : null}
            link={alternativeUrl ? alternativeUrl : link}
            buttonText={buttonText}
          />
        );
      });
    }
  }, [articles, isSearching]);

  const handlePageClick = (data) => {
    setPage(data.selected + 1);
  };

  const renderTabs = () => {
    return tabs.map((tab) => {
      if (!tab.text) {
        return (
          <div
            className={`clockworks-articles-tabmenu-item ${tab.name === category ? 'selected' : ''}`}
            key={`${tab.id}--${tab.slug}`}
            onClick={() => selectCategory(tab)}
          >
            {tab.name}
          </div>
        );
      }
    });
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsSearching(true);
    try {
      const res = await searchArticles(searchQuery);
      if (res.length) {
        const articlesDetails = await Promise.all(res.map(async (item) => {
          const articleDetails = await getArticleById(item.id);
          return articleDetails;
        }));
        setArticlesList(articlesDetails.filter(article => article !== null));
      } else {
        setArticlesList([]);
      }
    } catch (error) {
      console.error("Error searching articles:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="clockworks-articles-block">
      <div className="clockworks-articles-block-tabmenu-wrapper">
        <div className="clockworks-articles-tabmenu">
          {renderTabs()}
        </div>
      </div>
      <form
        className='clockworks-articles-search'
        onSubmit={handleSearch}
      >
        <div className='clockworks-articles-search-wrap'>
          <input
            className='clockworks-articles-search-input'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by keyword"
          />
          <button
            className='clockworks-articles-search-button'
            type="submit"
          >
            SEARCH
          </button>
        </div>
      </form>
        {!loading ? (
            <>
              <div className="clockworks-articles-block-container">
                {articlesCardsList}
              </div>
              {articles.length !== 0 &&
                <div className="clockworks-articles-pager">
                  <ReactPaginate
                    previousLabel={'«'}
                    nextLabel={'»'}
                    breakLabel={'...'}
                    pageCount={pagesCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    forcePage={page - 1}
                    containerClassName="clockworks-articles-pager-page"
                    pageClassName="clockworks-articles-pager-item"
                    pageLinkClassName="clockworks-articles-pager-link"
                    previousClassName="clockworks-articles-pager-item previous"
                    previousLinkClassName="clockworks-articles-pager-link"
                    nextClassName="clockworks-articles-pager-item next"
                    nextLinkClassName="clockworks-articles-pager-link"
                    breakClassName="clockworks-articles-pager-item break"
                    breakLinkClassName="clockworks-articles-pager-link"
                    activeClassName="active"
                  />
                </div>
              }
            </>
          ) : (
            <div className="clockworks-articles-nodata-container">
              <h2>Loading...</h2>
            </div>
          )
        }
    </div>
  );
};

export default ArticlesBlock;